module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_desk-b45c0112964e7db54e46c28f4d22d026.png";